import { editor } from "monaco-editor/esm/vs/editor/editor.api";

export interface CodeEditorInstance {
  instance?: editor.IStandaloneCodeEditor
}

export const codeEditorInstance: CodeEditorInstance = {
}